import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/app/[locale]/error.tsx");
